import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { ShortcutModalService } from '../shortcut-modal/shortcut-modal.service';
import { APP_CONFIG } from 'src/app/app.config';
import { Router } from '@angular/router';
import { NavigationItem, toggleNavSection } from 'src/app/store/navigation';
import { Store } from '@ngrx/store';
import { environment } from '../../../../environments/environment';
declare var $: any;


@Component({
  selector: 'smart-logo',
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  urlupload = environment.URLUPLOAD

  logo = sessionStorage.getItem("logo_small") && sessionStorage.getItem("logo_small") !== 'null' ? sessionStorage.getItem("logo_small") : APP_CONFIG.logo;
  appName = APP_CONFIG.appName;
  logoName = sessionStorage.getItem("logo_large") && sessionStorage.getItem("logo_large") !== 'null' ? sessionStorage.getItem("logo_large") : APP_CONFIG.logoName;

  username= sessionStorage.getItem("fname")+' '+sessionStorage.getItem("lname");

  @Input() item: NavigationItem;
  constructor(public shortcut: ShortcutModalService, private router: Router,  private store: Store<any>) { }

  openShortcut($event: MouseEvent) {
    $event.preventDefault();
    this.shortcut.openModal();

  }
  home() {
    this.router.navigate(["/home"]).then(() => {
      // $('#plotNameNav').addClass('dis-none');
      window.location.reload();
    });
  }

  // toggleSection($event: MouseEvent,id) {
  //   // alert(id);
  //   console.log("...toggleSection(id)..>>>", id)
  //   console.log("...toggleSection($event)..>>>", $event)
  //   $event.preventDefault();
  //   this.store.dispatch(toggleNavSection({ item: this.item }));
  //   // console.clear()
  //   console.log("item.....>>>>",this.item)
  // }

}
